import formatMediaObject from './format-media-object';

/**
 * Format the data for the product/grocery product carousel components.
 *
 * @param {object} context
 * @param {Array} items
 *
 * @returns {Array}
 */
const formatCarouselSlideData = (context, items) => {
    return (items || [])
        .filter(({ page }) => page)
        .map((item) => ({
            name: item.marketing_title,
            image: formatMediaObject
                .call(context, item.website_thumbnail_image),
            calories: item.calories,
            to: item.page.uri,
        }));
};

export const formatMenuSlides = formatCarouselSlideData;

export const formatGrocerySlides = formatCarouselSlideData;

export default formatCarouselSlideData;
